import dayjs from 'dayjs';
import 'dayjs/locale/uk';
import { Suspense } from 'react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import CommonLoader from './components/shared/loaders/CommonLoader';
import PrivateRouter from './layouts/PrivateRouter';
import Analytics from './pages/Analytics';
import Brands from './pages/Brands';
import Clients from './pages/Clients';
import Events from './pages/Events';
import Home from './pages/Home';
import Login from './pages/Login';
import Models from './pages/Models';
import Note from './pages/Note';
import Notes from './pages/Notes';
import Parts from './pages/Parts';
import Profile from './pages/Profile';
import Rates from './pages/Rates';
import Tasks from './pages/Tasks';
import Users from './pages/Users';
import Vehicle from './pages/Vehicle';
import Vehicles from './pages/Vehicles';
import Visit from './pages/Visit';

dayjs.locale('uk');

function App() {
  const userData = useSelector((state) => state.auth?.userData);
  return (
    <Suspense fallback={<CommonLoader />}>
      <Routes>
        <Route path="/login" element={userData ? <Navigate to="/" /> : <Login />} />
        <Route element={<PrivateRouter userData={userData} />}>
          <Route path="/" element={<Home />} />
          <Route path="/calendar" element={<Events />} />
          <Route path="/vehicles" element={<Vehicles />} />
          <Route path="/vehicles/:vin" element={<Vehicle />} />
          <Route path="/vehicles/:vin/visits/:visitId" element={<Visit />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/parts" element={<Parts />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/rates" element={<Rates />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/brands/:brandId/models" element={<Models />} />
          <Route path="/users" element={<Users />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/notes" element={<Notes />} />
          <Route path="/notes/:noteId" element={<Note />} />
          <Route path="/analytics" element={<Analytics />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
